<div
  class="flex cursor-pointer items-center bg-white px-4 py-2 hover:bg-neutral-200"
  (click)="select()">
  <span #content>
    <ng-content></ng-content>
  </span>
  <!-- <app-icon [name]="isSelected ? 'checked' : 'unchecked'" class="ml-auto" /> -->
  <img
    [src]="isSelected ? 'assets/images/icons/checked.svg' : 'assets/images/icons/unchecked.svg'"
    alt=""
    class="ml-auto" />
</div>
